import { SelectedOptionProps } from './Constants';

export const onClickSelectedOption = (props: SelectedOptionProps) => {
  const { isEnabled, imageSettingId, regionCaptureProfiles, setRegionCaptureProfiles } =
    props;
  const tempRegionCaptureProfiles = regionCaptureProfiles.map((rcp) => {
    if (rcp.id === imageSettingId) {
      rcp.imagingEnabled = isEnabled;
    }
    return rcp;
  });
  if (tempRegionCaptureProfiles.length > 0) {
    setRegionCaptureProfiles(tempRegionCaptureProfiles);
  }
};
